import * as moment from 'moment';
import { DateConverter, VisibiliteEnumConverter } from 'src/app/core/services/mapper/converters';
import { VisibiliteEnum } from './enums/visibilite.enum';
import { RefTypeFichier } from './ref-type-fichier.model';
import { VersionFichier } from './version-fichier.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class GedFichier {
    static jsonMap = {
        id: { key: 'id', optional: true },
        libelle: { key: 'libelle', optional: true, default: '' },
        uuid: { key: 'uuid', optional: true, default: '' },
        typeFichier: { key: 'typeFichier', converter: new (ClassConverterFactory.build(RefTypeFichier))(), optional: true },
        description: { key: 'description', optional: true, default: '' },
        dateUpload: { key: 'dateUpload', converter: new DateConverter(), optional: true },
        estPublic: { key: 'estPublic', optional: true },
        visibilite: { key: 'visibilite', converter: new VisibiliteEnumConverter(), optional: true },
        estArchive: { key: 'estArchive', optional: true },
        versions: { key: 'versions', converter: new (ArrayClassConverterFactory.build(VersionFichier))(), optional: true, default: () => [] },
        intervenants: { key: 'intervenants', optional: true, default: () => [] },
        entreprises: { key: 'entreprises', optional: true, default: () => [] },
        codeSousTypes: { key: 'codeSousTypes', optional: true, default: () => [] }
    };

    public id: number;
    public libelle: string;
    public uuid: string;
    public typeFichier: RefTypeFichier;
    public description: string;
    public dateUpload: moment.Moment;
    public estPublic: boolean;
    public visibilite: VisibiliteEnum;
    public estArchive: boolean;
    public versions: Array<VersionFichier>;
    public intervenants: Array<number>;
    public entreprises: Array<number>;
    public codeSousTypes: Array<string>;

    public currentVersion: VersionFichier;

    public getVersion(): VersionFichier | null {
        let version: VersionFichier = null;
        if (this.versions != null) {
            version = this.versions.sort((version1, version2) => version2.dateCreation.diff(version1.dateCreation))[0];
        }
        return version;
    }
}
